import { useAuth } from '../context/AuthContext';
import { useTenantSafe } from '../context/TenantContext';
import { canStaffSection } from '../utils/staffAccess';

export default function useSpeciesAccess() {
  const { user, access } = useAuth();
  const tenant = useTenantSafe();
  const tenantIds = tenant?.viewTenant?._id
    ? [tenant.viewTenant._id] : Object.keys(access?.communityRoles || {});
  const administrator = ['cip_admin', 'cip_staff'].includes(user?.globalRole);
  return {
    canEdit: administrator || tenantIds.some((id) =>
      canStaffSection(user, id, 'harvesting') || canStaffSection(user, id, 'stewardship')),
    canArchive: administrator || tenantIds.some((id) => canStaffSection(user, id, 'stewardship')),
  };
}
